import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", () => {

  const swiper = new Swiper('.swiper', {
    // configure Swiper to use modules
    modules: [Navigation, Pagination],
    loop: true,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  console.log("swiper", swiper);

});
